module.exports = __webpack_public_path__ + "static/img/245_TO8_2195.97c9459.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/245_TO8_2195.jpg
// module id = Hqel
// module chunks = 0